import React from 'react'
import classNames from 'classnames'

import { Progress } from '@/components/progress/Progress'

import './StatProgressBar.scss'

// Stat tile that wraps the shared `<Progress>` primitive with a labeled header
// (value / total, optional unit + rounded percent) and an optional two-slot
// footer. `<Progress>` owns the bar markup, a11y, clamping, and color
// variants — this component owns the layout around it. Keeping one bar
// primitive in the app means anyone who needs a "progress bar plus labels"
// reaches for this; anyone who needs a bare bar reaches for `<Progress>`.
export const StatProgressBar = ({
  label,
  value,
  total,
  unit,
  footerLeft,
  footerRight,
  variant,
  className,
}) => {
  const pct = total > 0 ? (value / total) * 100 : 0
  const showFooter = footerLeft || footerRight

  return (
    <div className={classNames('stat-progress-bar', className)}>
      <div className="stat-progress-bar__header">
        <span className="stat-progress-bar__label">{label}</span>
        <span className="stat-progress-bar__value">
          <strong>{value.toLocaleString()}</strong>
          {` / ${total.toLocaleString()}${unit ? ` ${unit}` : ''} `}
          <span className="stat-progress-bar__pct">{`(${Math.round(pct)}%)`}</span>
        </span>
      </div>
      <Progress
        value={pct}
        success={variant === 'success'}
        warning={variant === 'warning'}
        critical={variant === 'critical'}
        magical={variant === 'magical'}
        aria-label={label}
        data-testid="stat-progress-bar-fill"
      />
      {showFooter && (
        <div className="stat-progress-bar__footer">
          <span>{footerLeft}</span>
          {footerRight && <span>{footerRight}</span>}
        </div>
      )}
    </div>
  )
}
